<template>
  <svg width="20" height="20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.58 5.1a2.57 2.57 0 0 0-1.77-1.82C16.25 2.85 10 2.85 10 2.85s-6.25 0-7.82.43A2.5 2.5 0 0 0 .42 5.1C.13 6.74-.01 8.4 0 10.07c0 1.67.13 3.33.42 4.97a2.6 2.6 0 0 0 1.76 1.82c1.57.43 7.82.43 7.82.43s6.25 0 7.8-.43a2.57 2.57 0 0 0 1.77-1.82c.3-1.64.44-3.3.43-4.97 0-1.67-.13-3.33-.42-4.97ZM7.95 13.12v-6.1l5.23 3.05-5.23 3.05Z"
      fill="currentColor"
    />
  </svg>
</template>
